import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable, resource, signal } from '@angular/core';
import { finalize, lastValueFrom, tap } from 'rxjs';
import { LogsService } from '../logs/logs.service';
import { RegionService } from '../region/region.service';

// TODO: Confirm the real job name/mapping and endpoint paths once provided.
const SKU_MAPPING_JOB_NAME = 'Generic File Import-SkuMapping';

@Injectable({
  providedIn: 'root',
})
export class SkuMappingService {
  http = inject(HttpClient);
  logs = inject(LogsService);
  private readonly regions = inject(RegionService);

  uploadHistory = resource({
    params: () => this.regions.selectedRegionId(),
    loader: ({ params }) =>
      lastValueFrom(
        this.logs.getLogByMappedName$(SKU_MAPPING_JOB_NAME, params),
      ),
  });

  noUploadHistory = computed(() => this.uploadHistory.status() === 'error');

  skuMappingFileUploading = signal<boolean>(false);
  skuMappingFileUploadError = signal<boolean>(false);
  skuMappingFileUploadProgress = signal<number | undefined>(undefined);

  uploadSkuMappingFile = (file: File, salesChannelCode: string) => {
    this.skuMappingFileUploading.set(true);
    const formData = new FormData();
    formData.append('file', file, file.name);
    const params = new HttpParams()
      .set('dataType', 'SkuMapping')
      .set('regionId', this.regions.selectedRegionId() ?? '')
      .set('salesChannelCode', salesChannelCode);

    return this.http
      .post(
        'GenericDataImport/uploadfile',
        formData,
        {
          reportProgress: true,
          observe: 'events',
          params,
        },
      )
      .pipe(
        tap((event) => {
          // Handle download progress as error
          if (event.type === HttpEventType.DownloadProgress) {
            this.skuMappingFileUploadError.set(true);
          }

          if (
            event.type === HttpEventType.UploadProgress ||
            event.type === HttpEventType.DownloadProgress
          ) {
            const progress = Math.round(
              (100 * event.loaded) / (event.total || 1),
            );
            this.skuMappingFileUploadProgress.set(progress);
          }
        }),
        finalize(() => {
          this.skuMappingFileUploading.set(false);
          this.skuMappingFileUploadError.set(false);
        }),
      );
  };

  downloadSkuMappingFile = (salesChannelCode?: string) => {
    const params = new HttpParams().set(
      'region_id',
      this.regions.selectedRegionId() ?? '',
    );

    return this.http.get(`Product/skumapping/download/${salesChannelCode}`, {
      responseType: 'blob',
      observe: 'response',
      params,
    });
  };
}
